import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MILLIS_PER_HOUR } from '@shared/constants/time.constants';
import { catchError, map, of } from 'rxjs';
import { I18nService } from '../i18n.service';

export type ResolvedI18nData = { i18nData: any } | { error: any };

export const i18nResolver: ResolveFn<ResolvedI18nData> = () => {
    const i18nService = inject(I18nService);

    return i18nService.loadTranslations(12 * MILLIS_PER_HOUR).pipe(
        map((i18nData) => ({ i18nData })),
        catchError((error) => of({ error })),
    );
};
